/** @jsxImportSource @emotion/react */
import { TooltipWrapper } from 'components/atoms/TooltipWrapper'
import React from 'react'

// A delivery channel with its outcome, e.g. "SMS [Sent]".
export const DeliveryBadge: React.FC<{
  channel: string
  label: string
  color: string
  tooltip?: string
}> = ({ channel, label, color, tooltip }) => (
  <div css={{ display: 'flex', alignItems: 'center', gap: 6 }}>
    <span>{channel}</span>
    <TooltipWrapper text={tooltip || ''} show={!!tooltip}>
      <span
        css={{
          background: color,
          color: '#fff',
          borderRadius: 6,
          padding: '0.15rem 0.4rem',
          fontSize: 12,
          whiteSpace: 'nowrap',
          cursor: tooltip ? 'help' : undefined,
        }}>
        {label}
      </span>
    </TooltipWrapper>
  </div>
)
